import type { ViewRenderer } from ".";
import { SvgService } from "../../../services/SvgService";

export const lineRenderer: ViewRenderer = (
	svgElem,
	delaunayTriangles,
	canvas,
) => {
	const { points, selectedPoints, showVertices } = canvas;

	// Create triangles using DocumentFragment for better performance
	const triangleElements: SVGPolygonElement[] = [];

	// Draw triangles
	for (let i = 0; i < delaunayTriangles.length; i += 3) {
		const p1 = delaunayTriangles[i];
		const p2 = delaunayTriangles[i + 1];
		const p3 = delaunayTriangles[i + 2];

		const polygon = SvgService.createSvgElement("polygon");

		polygon.setAttribute(
			"points",
			`${points[p1][0]},${points[p1][1]} ${points[p2][0]},${points[p2][1]} ${points[p3][0]},${points[p3][1]}`,
		);
		polygon.setAttribute("fill", "none");
		polygon.setAttribute("stroke", "currentcolor");

		triangleElements.push(polygon);
	}

	// Batch append all triangles
	SvgService.batchAppendChildren(svgElem, triangleElements);

	// Add individual point circles for selection (if enabled)
	if (showVertices) {
		const pointElements: SVGCircleElement[] = [];
		points.forEach((point, index) => {
			const pointCircle = SvgService.createSvgElement("circle");
			pointCircle.setAttribute("cx", point[0].toString());
			pointCircle.setAttribute("cy", point[1].toString());
			pointCircle.setAttribute("r", "4");
			pointCircle.setAttribute(
				"fill",
				selectedPoints.includes(index)
					? "#ff6b35"
					: "rgba(255, 255, 255, 0.8)",
			);
			pointCircle.setAttribute(
				"stroke",
				selectedPoints.includes(index) ? "#ff6b35" : "currentcolor",
			);
			pointCircle.setAttribute("stroke-width", "2");
			pointCircle.setAttribute("cursor", "pointer");
			pointCircle.dataset.pointIndex = index.toString();
			pointElements.push(pointCircle);
		});

		SvgService.batchAppendChildren(svgElem, pointElements);
	}
};
